const InputField = ({
  label,
  placeholder,
  value,
  onChange,
  readOnly,
  type,
}) => {
  return (
    <>
      <label className="label" htmlFor="">
        {label}
      </label>
      <div className={"filter-dropdown-cross"}>
        <input
          className="input-field"
          placeholder={placeholder || "Enter Value"}
          value={value}
          readOnly={readOnly}
          {...(type ? { type } : {})}
          onChange={(e) => onChange(e.target.value)}
        />
      </div>
    </>
  );
};

export default InputField;
